import produce from "immer";
import {enableES5} from "immer";
import {createAction, handleActions} from 'redux-actions';

enableES5();

const initialState = {
    config: {},
    defaultThumb: 'https://wstatic-cdn.plaync.com/plaync/gameinfo/img/thumb-lineagew.png',
    isParamsLoaded: false,

    detail: null,
    page: 0,
    query: '',
    favorite: 'false',
    favDetail: {
        id: null,
        isFavorite: false
    },

    grades: '',
    class: '',
    category1: '',
    category2: '',
    learn: '',
    spelltype: '',
    elemental: '',
    card: '',
    buffcard: '',
    weapon: '',
    field: '',

    craftinputid: '',
    craftoutputid: '',
};


// actions--------------------------------------------------------------------------------
export const actions = {
    setConfig: createAction('GI_LW/SET_CONFIG'),
    setIsParamsLoaded: createAction('GI_LW/SET_IS_PARAMS_LOADED'),
    
    setDetail: createAction('GI_LW/SET_DETAIL'),
    setPage: createAction('GI_LW/SET_PAGE'),
    setQuery: createAction('GI_LW/SET_QUERY'),
    setFavorite: createAction('GI_LW/SET_FAVORITE'),
    setFavDetail: createAction('GI_LW/SET_FAVDETAIL'),

    setGrades: createAction('GI_LW/SET_GRADES'),
    setClass: createAction('GI_LW/SET_CLASS'),
    setCategory1: createAction('GI_LW/SET_CATEGORY1'),
    setCategory2: createAction('GI_LW/SET_CATEGORY2'),
    setLearn: createAction('GI_LW/SET_LEARN'),
    setSpelltype: createAction('GI_LW/SET_SPELLTYPE'),
    setElemental: createAction('GI_LW/SET_ELEMENTAL'),
    setCard: createAction('GI_LW/SET_CARD'),
    setBuffcard: createAction('GI_LW/SET_BUFFCARD'),
    setWeapon: createAction('GI_LW/SET_WEAPON'),
    setField: createAction('GI_LW/SET_FIELD'),

    setCraftInputId: createAction('GI_LW/SET_CRAFTINPUTID'),
    setCraftOutputId: createAction('GI_LW/SET_CRAFTOUTPUTID'),
};

// handlers--------------------------------------------------------------------------------
export default handleActions({
    [actions.setConfig] : (state, action) => produce(state, draft => {draft.config = action.payload;}),
    [actions.setIsParamsLoaded] : (state, action) => produce(state, draft => {draft.isParamsLoaded = action.payload;}),
    
    [actions.setDetail] : (state, action) => produce(state, draft => {draft.detail = action.payload;}),
    [actions.setPage] : (state, action) => produce(state, draft => {draft.page = action.payload;}),
    [actions.setQuery] : (state, action) => produce(state, draft => {draft.query = action.payload;}),
    [actions.setFavorite] : (state, action) => produce(state, draft => {draft.favorite = action.payload;}),
    [actions.setFavDetail] : (state, action) => produce(state, draft => {draft.favDetail = action.payload;}),

    [actions.setGrades] : (state, action) => produce(state, draft => {draft.grades = action.payload;}),
    [actions.setClass] : (state, action) => produce(state, draft => {draft.class = action.payload;}),
    [actions.setCategory1] : (state, action) => produce(state, draft => {draft.category1 = action.payload;}),
    [actions.setCategory2] : (state, action) => produce(state, draft => {draft.category2 = action.payload;}),
    [actions.setLearn] : (state, action) => produce(state, draft => {draft.learn = action.payload;}),
    [actions.setSpelltype] : (state, action) => produce(state, draft => {draft.spelltype = action.payload;}),
    [actions.setElemental] : (state, action) => produce(state, draft => {draft.elemental = action.payload;}),
    [actions.setCard] : (state, action) => produce(state, draft => {draft.card = action.payload;}),
    [actions.setBuffcard] : (state, action) => produce(state, draft => {draft.buffcard = action.payload;}),
    [actions.setWeapon] : (state, action) => produce(state, draft => {draft.weapon = action.payload;}),
    [actions.setField] : (state, action) => produce(state, draft => {draft.field = action.payload;}),

    [actions.setCraftInputId] : (state, action) => produce(state, draft => {draft.craftinputid = action.payload;}),
    [actions.setCraftOutputId] : (state, action) => produce(state, draft => {draft.craftoutputid = action.payload;}),
}, initialState);